import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import FertilizerGroupBarGraph from './FertilizerGroupBarGraph';
import FertilizerGroupPieChart from './FertilizerGroupPieChart';

export default function FertilizerGraphPairForGroups({ barGraphData, pieChartData, companyName, year, type, unit }) {
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'fertilizer'}>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                <FertilizerGroupBarGraph data={barGraphData} companyName={companyName} type={type} year={year} unit={unit} />
            </Grid>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                <FertilizerGroupPieChart data={pieChartData} companyName={companyName} type={type} year={year} unit={unit} />
            </Grid>
        </NoGraphData>
    )
}